import {
  LegalLayout,
  Section,
  SubList,
} from "../components/legal/LegalLayout";

export default function Shipping() {
  return (
    <LegalLayout
      title="Shipping & Pre-Order Policy"
      updated="August 11, 2026"
      pageTestId="page-shipping"
    >
      <Section title="1. Company details">
        <SubList
          items={[
            "Legal name: IVORY PULSE SRL",
            "Registration (CUI): 52619680",
            "Contact: support@ivory-pulse.com",
            "Registered office: Romania",
          ]}
        />
      </Section>

      <Section title="2. Pre-sale window">
        <p>
          The Pulse One — Founders Edition pre-sale is <strong>coming soon</strong>.
          The opening date will be announced. Until then, the site is waitlist-only
          and no payments are collected. Waitlist members are notified by
          email when pre-sale goes live and will have priority access to the
          first 1,000 Founders Edition units at the founder price of{" "}
          <strong>$300</strong>.
        </p>
      </Section>

      <Section title="3. Estimated shipping window">
        <p>
          Estimated shipping is{" "}
          <strong>late summer / autumn 2026</strong>. This is an estimate
          based on our current development and manufacturing plan. Shipping
          dates may change as we finalise certification, manufacturing and
          logistics.
        </p>
        <p>
          <strong>
            Estimated shipping dates are not delivery guarantees.
          </strong>{" "}
          We will keep pre-order customers informed by email as milestones are
          hit.
        </p>
      </Section>

      <Section title="4. Prototype disclaimer">
        <p>
          Final product imagery is intentionally withheld until the design
          reveal. Final product specifications, materials, finishes, packaging
          and software experience may evolve before shipment. Where changes
          become material, we will inform affected customers before
          fulfilment.
        </p>
      </Section>

      <Section title="5. Address collection">
        <p>
          Your shipping address will be collected either at checkout when the
          pre-sale opens, or before fulfilment via a secure confirmation email.
          Please keep your email address up to date and notify us promptly of
          any change so we can reach you before dispatch.
        </p>
      </Section>

      <Section title="6. Shipping fees and destinations">
        <p>
          Shipping fees will be calculated at checkout based on destination,
          package weight and the carrier options available at that time. We
          will publish the supported destinations before payments open. Some
          regions may be excluded initially for regulatory or logistics
          reasons.
        </p>
      </Section>

      <Section title="7. Import duties, taxes and customs">
        <p>
          Import duties, VAT, GST and other taxes may apply depending on your
          destination and applicable law. Unless otherwise stated at checkout,
          these charges are the responsibility of the recipient and are
          collected by the carrier or local tax authority at the time of
          delivery.
        </p>
      </Section>

      <Section title="8. Notification and tracking">
        <p>
          Once your unit is dispatched, you will receive a shipment
          notification with tracking information. Please check the tracking
          link for the most up-to-date delivery status.
        </p>
      </Section>

      <Section title="9. Delays">
        <p>
          Hardware schedules can slip. If we anticipate a significant delay to
          the estimated shipping window, we will notify pre-order customers by
          email with an updated expected date and, where appropriate,
          information on your options under our Refund &amp; Cancellation
          Policy.
        </p>
      </Section>

      <Section title="10. Delivery issues">
        <p>
          If your Pulse One arrives damaged, incomplete, or is not delivered
          within a reasonable time of the carrier’s estimate, please contact
          us at{" "}
          <a
            className="underline decoration-white/30 hover:decoration-white"
            href="mailto:support@ivory-pulse.com"
          >
            support@ivory-pulse.com
          </a>{" "}
          with your order reference so we can investigate with the carrier
          and find a resolution.
        </p>
      </Section>

      <Section title="11. Changes">
        <p>
          This Shipping &amp; Pre-Order Policy may be updated before payments
          open. Any change will be published on this page, and material
          changes will be communicated to pre-order customers where
          appropriate.
        </p>
      </Section>
    </LegalLayout>
  );
}
